(() => {
  if (window.__fareverChannelAnalyticsReady) return;
  window.__fareverChannelAnalyticsReady = true;

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest?.('[data-farever-channel-event]');
      if (!control || control.disabled || control.getAttribute?.('aria-disabled') === 'true') return;

      const form = control.closest?.('product-form')?.querySelector('form');
      const formData = form && typeof FormData === 'function' ? new FormData(form) : null;
      const variantId = formData?.get('id') || control.dataset.variantId || '';
      const requestedQuantity = Number.parseInt(formData?.get('quantity') || '1', 10);
      const quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
      const amazonUrl = control.href || '';
      const asinMatch = amazonUrl.match(/\/dp\/([A-Z0-9]{10})(?:[/?#]|$)/i);
      const priceCents = Number(control.dataset.priceCents);

      const eventData = {
        purchase_channel: control.dataset.purchaseChannel || '',
        purchase_action: control.dataset.purchaseAction || '',
        product_id: control.dataset.productId || '',
        variant_id: String(variantId),
        product_title: control.dataset.productTitle || '',
        product_handle: control.dataset.productHandle || '',
        quantity,
        amazon_url: amazonUrl,
        asin: asinMatch ? asinMatch[1].toUpperCase() : '',
        price_amount: Number.isFinite(priceCents) ? (priceCents / 100).toFixed(2) : '',
        currency: control.dataset.currency || '',
      };

      const published = window.Shopify?.analytics?.publish?.(
        control.dataset.fareverChannelEvent,
        eventData
      );
      if (published && typeof published.catch === 'function') {
        published.catch(() => {});
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: control.dataset.fareverDatalayerEvent,
        ...eventData,
      });

      control.dataset.fareverAnalyticsTracked = 'true';
    },
    { capture: true, passive: true }
  );
})();
